export default __webpack_public_path__ + "static/media/superlotto.496c8edb.png";